import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { FaBars, FaTimes } from 'react-icons/fa';

function MobileNav({ user, logout }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
    toast.success('Logged out successfully');
    navigate('/');
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="w-full bg-white shadow-md p-4 sticky top-0 z-50">
      <div className="flex justify-between items-center">
        <Link
          to="/"
          className="flex items-center gap-2 focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-2 py-1"
          onClick={handleNavClick}
        >
          <img src="/resume-logo.png" alt="Resume Hero Logo" className="h-10 w-auto" />
          <span className="text-lg sm:text-xl font-bold text-blue-600 hidden sm:inline">Resume-Hero</span>
        </Link>

        {/* Hamburger button for mobile */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden flex items-center justify-center p-2 h-12 w-12 rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-menu"
        >
          {isMenuOpen ? (
            <FaTimes className="text-2xl text-blue-600" />
          ) : (
            <FaBars className="text-2xl text-blue-600" />
          )}
        </button>

        {/* Desktop menu */}
        <div className="hidden md:flex space-x-4">
          {!user && (
            <Link
              to="/login"
              className="text-blue-600 hover:underline focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-3 py-2 transition"
            >
              Login
            </Link>
          )}

          {user && (
            <>
              <Link
                to="/dashboard"
                className="text-blue-600 hover:underline focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-3 py-2 transition"
              >
                Dashboard
              </Link>
              <Link
                to="/builder"
                className="text-blue-600 hover:underline focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-3 py-2 transition"
              >
                Builder
              </Link>
              <Link
                to="/profile-settings"
                className="text-blue-600 hover:underline focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-3 py-2 transition"
              >
                Settings
              </Link>
              <button
                onClick={handleLogout}
                className="text-red-600 hover:underline focus:ring-2 focus:ring-red-500 focus:outline-none rounded px-3 py-2 transition"
              >
                Logout
              </button>
            </>
          )}
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div
          id="mobile-menu"
          className="md:hidden mt-4 pt-4 border-t border-gray-200 space-y-3"
        >
          {!user && (
            <Link
              to="/login"
              className="block text-blue-600 hover:bg-blue-50 focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-4 py-3 transition font-medium"
              onClick={handleNavClick}
            >
              Login
            </Link>
          )}

          {user && (
            <>
              <Link
                to="/dashboard"
                className="block text-blue-600 hover:bg-blue-50 focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-4 py-3 transition font-medium"
                onClick={handleNavClick}
              >
                Dashboard
              </Link>
              <Link
                to="/builder"
                className="block text-blue-600 hover:bg-blue-50 focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-4 py-3 transition font-medium"
                onClick={handleNavClick}
              >
                Builder
              </Link>
              <Link
                to="/profile-settings"
                className="block text-blue-600 hover:bg-blue-50 focus:ring-2 focus:ring-blue-500 focus:outline-none rounded px-4 py-3 transition font-medium"
                onClick={handleNavClick}
              >
                Profile Settings
              </Link>
              <button
                onClick={handleLogout}
                className="block w-full text-left text-red-600 hover:bg-red-50 focus:ring-2 focus:ring-red-500 focus:outline-none rounded px-4 py-3 transition font-medium"
              >
                Logout
              </button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}

export default MobileNav;
